// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__Ppl0V","content":"Error_content__WrDhA","mobile":"Error_mobile__bjBgW"};